import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import * as Yup from 'yup';
const AddEmployee = () => {
    const [gender, setGender] = useState("Male");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const initialValues = {
        employeeName: '',
        shortName: '',
        gender: 'Male',
        dob: '',
        marriageDate: '',
        address1: '',
        address2: '',
        address3: '',
        pinCode: '',
        city: '',
        state: '',
        employeeCode: '',
        mobile: '',
        email: '',
        designation: '',
        branch: '',
        pan: '',
        reportsTo: '',
        joiningDate: '',
        terminationDate: '',
        aadhar: ''
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string().required("First name is required"),
        dob: Yup.string().required("Dob is required"),
        gender: Yup.string().required("Gender is required"),
        address1: Yup.string().required("Address 1 is required"),
        email: Yup.string()
            .email('Enter a valid email address')
            .required('Email is required'),

        mobile: Yup.string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
            .required('Mobile number is required'),
        pan: Yup.string()
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format')
            .required('PAN is required'),
        aadhar: Yup.string()
            .matches(/^[0-9]{12}$/, 'Aadhar must be 12 digits')
            .required('Aadhar is required'),
    });

    // Utility function to allow only numbers
    const allowOnlyNumbers = (e) => {
        const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <div className="formContainer lg:p-4 rounded" style={{ boxShadow: "0 0 8px #ccc" }}>
            <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
                <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
                    Add Employee
                </h5>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        console.log("Submitted values:", values);
                    }}
                >
                    {() => (
                        <Form>
                            {/* Customer Type */}
                            <div className="row">
                                <div className="col-lg-6 col-12 mb-3">
                                    <label className="form-label">
                                        Employee Name <span className="text-danger">*</span>
                                    </label>
                                    <Field name="employeeName" className="form-control custom-shadow" />
                                    <ErrorMessage name="employeeName" component="div" className="text-danger" />
                                </div>

                                <div className="col-lg-6 col-12 mb-3">
                                    <label className="form-label">Short Name</label>
                                    <Field name="shortName" className="form-control custom-shadow" />
                                </div>

                                {/* Gender */}
                                <div className="col-lg-4 col-12 mb-3">
                                    <label className="d-block form-label">
                                        Gender <span className="text-danger">*</span>
                                    </label>
                                    <div className="d-flex gap-2">
                                        <button
                                            type="button"
                                            className={`toggle-btn ${gender === "Male" ? "active" : ""}`}
                                            onClick={() => setGender("Male")}
                                        >
                                            Male
                                        </button>
                                        <button
                                            type="button"
                                            className={`toggle-btn ${gender === "Female" ? "active" : ""}`}
                                            onClick={() => setGender("Female")}
                                        >
                                            Female
                                        </button>
                                    </div>
                                    <ErrorMessage name="gender" component="div" className="text-danger" />
                                </div>

                                <div className="col-lg-4 col-12 mb-3">
                                    <label className="form-label">
                                        Date of Birth <span className="text-danger">*</span>
                                    </label>
                                    <Field type="date" name="dob" className="form-control custom-shadow" />
                                    <ErrorMessage name="dob" component="div" className="text-danger" />
                                </div>

                                <div className="col-lg-4 col-12 mb-3">
                                    <label className="form-label">Marriage Date</label>
                                    <Field type="date" name="marriageDate" className="form-control custom-shadow" />
                                </div>

                                {/* Address Section */}
                                <h6 className="text-secondary fw-bold mb-3 lg:mt-5 mt-3 bg-gray-100 rounded p-2">
                                    Address Information
                                </h6>
                            </div>

                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Address 1 <span className="text-danger">*</span>
                                    </label>
                                    <Field name="address1" className="form-control custom-shadow" />
                                    <ErrorMessage name="address1" component="div" className="text-danger" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Address 2</label>
                                    <Field name="address2" className="form-control custom-shadow" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Address 3</label>
                                    <Field name="address3" className="form-control custom-shadow" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Pin Code</label>
                                    <Field name="pinCode" className="form-control custom-shadow" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">City</label>
                                    <Field name="city" className="form-control custom-shadow" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">State</label>
                                    <Field name="state" className="form-control custom-shadow" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Employee Code</label>
                                    <Field name="employeeCode" className="form-control custom-shadow" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Mobile <span className="text-danger">*</span>
                                    </label>
                                    <Field name="mobile" className="form-control custom-shadow" maxLength={10} onKeyDown={allowOnlyNumbers} />
                                    <ErrorMessage name="mobile" component="div" className="text-danger" />
                                </div>

                                <div className="col-md-4 mb-3">
                                    <label className="form-label">Email <span className="text-danger">*</span>
                                    </label>
                                    <Field name="email" className="form-control custom-shadow" />
                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                </div>
                            </div>

                            {/* Professional Section */}
                            <h6 className="text-secondary fw-bold mb-3 lg:mt-5 mt-3 bg-gray-100 rounded p-2">
                                Professional Information
                            </h6>
                            <div className="row">
                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Designation</label>
                                    <Field as="select" name="designation" className="form-control custom-shadow">
                                        <option value="">Select Designation</option>
                                        <option value="Manager">Manager</option>
                                        <option value="Developer">Developer</option>
                                    </Field>
                                </div>

                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Branch</label>
                                    <Field as="branch" name="branch" className="form-control custom-shadow">
                                        <option value="">Select Branch</option>

                                    </Field>

                                </div>

                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Pan <span className="text-danger">*</span>
                                    </label>
                                    <Field name="pan"
                                        className="form-control custom-shadow text-uppercase"
                                        maxLength={10}
                                    />
                                    <ErrorMessage name="pan" component="div" className="text-danger" />
                                </div>

                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Joining Date  <span className="text-danger">*</span></label>
                                    <Field type="date" name="joiningDate" className="form-control custom-shadow" />
                                    <ErrorMessage name="joiningDate" component="div" className="text-brandRed" />
                                </div>

                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Reports To</label>
                                    <Field as="branch" name="reportsTo" className="form-control custom-shadow">
                                        <option value="">Select </option>
                                    </Field>
                                </div>

                                <div className="col-lg-4 mb-3">
                                    <label className="form-label">Termination Date </label>
                                    <Field type="date" name="terminationDate" className="form-control custom-shadow" />
                                </div>

                                <div className="col-lg-12 mt-3">
                                    <label className="form-label">Notes</label>
                                    <Field as="textarea" name="notes" className="form-control custom-shadow" rows="2" />
                                </div>
                            </div>
                            {/* Buttons */}
                            <div className="d-flex justify-content-center gap-3 mt-5">
                                <button type="submit" className="saveButton d-flex align-items-center px-4" disabled={isSubmitting}>
                                    <LuSave className="me-2" />
                                    {isSubmitting ? "Saving..." : "Save"}
                                </button>
                                <button type="button" className="backButton d-flex align-items-center px-4" onClick={() => window.history.back()}>
                                    <GiCrossedBones className="me-2" />
                                    Cancel
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddEmployee;
